<template>
  <div>
    <dialog-email
      ref="dialogEmail"
      :contentKey="contentKey"
      :contentMap="contentData"
      :data="emailData"
      @on-submit-email="onSubmitEmail"
    >
    </dialog-email>
    <dialog-alert
      ref="dialogAlert"
      :config="configAlert"
    >
    </dialog-alert>
  </div>
</template>

<script>
import { ServiceRFQs } from '@/services/RFQs'
import { api } from '@/services/api'
import { ServiceEmailMessages } from '@/services/email-messages'

export default {
  name: 'SendQuoteToCustomerEmailPart',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index'),
    'dialog-alert': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogAlert')
  },
  props: {
    rfqID: { required: true }
  },
  data () {
    return {
      rfq1ID: null,
      dataRFQ: {},
      dataRFQ1: {},
      emailData: {},
      contentData: {}
    }
  },
  computed: {
    configAlert () {
      return {
        title: this.L10n('general-warning'),
        text: this.L10n('please-select-contact')
      }
    },
    contentKey () {
      return 'quote-no-stock-to-customer'
    },
    emailSubject () {
      let partNumber = this.dataRFQ1.partNumber || ''
      return `Your RFQ - P/N: ${partNumber} - No Stock`
    }
  },
  methods: {
    show ({ id }) {
      this.rfq1ID = id
      this.loadData()
        .then(() => {
          if (!this.dataRFQ.customerContactID) {
            return this._showAlert()
          } else {
            return this._showEmail()
          }
        })
    },
    hide () {
      this.rfq1ID = null
      this.dataRFQ = {}
      this.dataRFQ1 = {}
      this.contentData = {}

      this._hideEmail()
      this._hideAlert()
    },
    onSubmitEmail (data) {
      this.requestSubmitEmail(data)
    },
    requestSubmitEmail (data) {
      return ServiceEmailMessages.send(data)
        .then(() => {
          this.requestSuccessHandler()
          this.$emit('onSuccess')
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.hide()
        })
    },
    loadData () {
      return Promise
        .all([
          this.loadDataRFQ(),
          this.loadDataRFQ1()
        ])
        .then(() => {
          this.contentData = this._createContentData(this.dataRFQ, this.dataRFQ1)
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
    },
    loadDataRFQ () {
      let params = {
        select: [
          'id', 'customerCompany.name as customerCompanyName', 'customerContact.name as customerContactName', 'baxEmployee',
          'priority', 'customerContactID', 'customerContact.email as email'
        ].join(',')
      }
      return ServiceRFQs.getDynamic(this.rfqID, params)
        .then(({ data }) => {
          this.dataRFQ = data
        })
    },
    loadDataRFQ1 () {
      let params = {
        'select': [
          'id', 'part.partNumber as partNumber', 'qty'
        ].join(','),
        'filter': `id == ${this.rfq1ID}`
      }
      return api
        .get(`RFQ1s/GetAllDynamic`, { params })
        .then(({ data }) => {
          let _data = data.value[0]
          if (_data) {
            this.dataRFQ1 = _data
          } else {
            return Promise.reject(new Error())
          }
        })
    },
    _showEmail () {
      this._createEmailData()
      this.$refs.dialogEmail.show()
    },
    _showAlert () {
      this.$notify
        .warning({
          title: this.L10n('general-warning'),
          message: this.L10n('please-select-contact'),
          position: 'bottom-right'
        })
      this.$refs.dialogAlert.show()
    },
    _hideEmail () {
      this.emailData = {}
      this.$refs.dialogEmail.hide()
    },
    _hideAlert () {
      this.$refs.dialogAlert.hide()
    },
    _createEmailData () {
      const { email } = this.dataRFQ
      let subject = this.emailSubject
      let emailToList = []
      email && emailToList.push(email)
      let _data = {
        subject,
        emailToList
      }
      this.emailData = _data
    },
    _createContentData (dataRFQ, dataRFQ1) {
      const { customerContactName, customerCompanyName } = dataRFQ
      const { partNumber, qty } = dataRFQ1
      const result = {
        customerContactName,
        customerCompanyName,
        partNumber,
        qty
      }
      return result
    }
  }
}
</script>
